import React from 'react'
import DateSelector from '@/components/Editors/DateSelector'
import { Frequency, VALUES } from '@/enums/Frequency'
import { DueDateWeekly } from '@/enums/DueDateWeekly'
import { Row, Col, FormGroup, Input, Label } from 'reactstrap'
import InfoContentEditable from '@/components/Editors/InfoContentEditable'
import { toUtcDate } from '@/utils/dateUtilities'

const extractPropertiesFromReportingCycle = (reportingCycle) => {
  const { id, name, latinName, frequency, snapshotDateValue, snapshotIntValue, snapshotOffset, dueDateValue, dueIntValue, dueOffset, extendedGraceDueDate, year } = reportingCycle
  return {
    id,
    name,
    latinName,
    frequency,
    snapshotDateValue,
    snapshotIntValue,
    snapshotOffset: (snapshotOffset !== null && snapshotOffset !== undefined ? snapshotOffset.toString() : ''),
    dueDateValue,
    dueIntValue,
    dueOffset: (dueOffset != null && dueOffset !== undefined ? dueOffset.toString() : ''),
    extendedGraceDueDate,
    year
  }
}
const prepareInputDto = (state) => {
  const { id, frequency, name, latinName, year, extendedGraceDueDate } = state
  const input = { id, frequency, name, latinName, year, extendedGraceDueDate }

  switch (frequency) {
    case Frequency.DAILY:
      input.dueOffset = Number(state.dueOffset)
      break

    case Frequency.QUARTERLY:
    case Frequency.MONTHLY:
    case Frequency.WEEKLY:
    case Frequency.BIWEEKLY:
      input.snapshotIntValue = state.snapshotIntValue
      input.snapshotOffset = Number(state.snapshotOffset)
      input.dueIntValue = state.dueIntValue
      input.dueOffset = Number(state.dueOffset)
      break

    case Frequency.YEARLY:
      input.snapshotDateValue = state.snapshotDateValue
      input.dueDateValue = state.dueDateValue
      break

    default:
      break
  }

  return input
}
class ReportingCycleEditor extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = extractPropertiesFromReportingCycle(props.reportingCycle)
  }

  onChange () {
    const input = prepareInputDto(this.state)
    if (this.props.onChange) { this.props.onChange(input) }
  }
  handleFrequencyChange (frequency) {
    switch (frequency) {
      case Frequency.DAILY:
      case Frequency.MONTHLY:
      case Frequency.QUARTERLY:
        this.setState({ snapshotIntValue: 0, snapshotDateValue: null, snapshotOffset: '0', dueIntValue: 0, dueDateValue: null, dueOffset: '0', frequency: frequency }, () => this.onChange())
        break
      case Frequency.WEEKLY:
      case Frequency.BIWEEKLY:
        this.setState({ snapshotIntValue: DueDateWeekly.WEEK_DAY, snapshotDateValue: null, snapshotOffset: '0', dueIntValue: DueDateWeekly.WEEK_DAY, dueDateValue: null, dueOffset: '0', frequency: frequency }, () => this.onChange())
        break

      case Frequency.YEARLY:
        const date = toUtcDate(new Date(this.props.year.number, 0, 1))
        this.setState({ snapshotDateValue: date, snapshotIntValue: 0, snapshotOffset: '', dueDateValue: date, dueIntValue: 0, dueOffset: '', frequency: frequency }, () => this.onChange())
        break
      default:
        break
    }
  }
  render () {
    const { localize, disabled } = this.props
    return (
      <React.Fragment>
        <FormGroup>
          <Label>{localize('Common.Name')}</Label>
          <Input disabled={disabled} type='text' value={this.state.name} onChange={e => this.setState({ name: e.target.value }, () => this.onChange())} />
        </FormGroup>
        <FormGroup>
          <Label>{localize('Common.LatinName')}</Label>
          <Input disabled={disabled} type='text' value={this.state.latinName} onChange={e => this.setState({ latinName: e.target.value }, () => this.onChange())} />
        </FormGroup>
        <Row>
          <Col sm='6'>
            <FormGroup>
              <Label>{localize('Reporting.Frequency')}</Label>
              <InfoContentEditable disabled={disabled} type='enum' localize={localize} editingEnabled enumName='Frequency' enumValues={VALUES} value={this.state.frequency} onChange={value => this.handleFrequencyChange(value)} />
            </FormGroup>
          </Col>
          <Col sm='6'>
            <FormGroup>
              <Label>{localize('Reporting.ExtendedGraceDueDate')}</Label>
              <Input disabled={disabled} type='number' value={this.state.extendedGraceDueDate} onChange={e => this.setState({ extendedGraceDueDate: e.target.value }, () => this.onChange())} />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <Label>{localize('Reporting.SnapshotDate')}</Label>
          <DateSelector editingEnabled
            disabled={disabled}
            frequency={this.state.frequency}
            dateValue={this.state.snapshotDateValue}
            intValue={this.state.snapshotIntValue}
            offset={this.state.snapshotOffset}
            onIntValueChange={value => this.setState({ snapshotIntValue: value }, () => this.onChange())}
            onDateValueChange={value => this.setState({ snapshotDateValue: value }, () => this.onChange())}
            onOffsetChange={offset => this.setState({ snapshotOffset: offset }, () => this.onChange())}
            localize={localize} />
        </FormGroup>
        <FormGroup>
          <Label>{localize('Reporting.DueDate')}</Label>
          <DateSelector editingEnabled isDueDate
            disabled={disabled}
            frequency={this.state.frequency}
            dateValue={this.state.dueDateValue}
            intValue={this.state.dueIntValue}
            offset={this.state.dueOffset}
            onIntValueChange={value => this.setState({ dueIntValue: value }, () => this.onChange())}
            onDateValueChange={value => this.setState({ dueDateValue: value }, () => this.onChange())}
            onOffsetChange={offset => this.setState({ dueOffset: offset }, () => this.onChange())}
            localize={localize} />
        </FormGroup>
      </React.Fragment>
    )
  }
}

export default ReportingCycleEditor



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportingCycles/editor.js